export enum UserStatus {
  LOGIN_COMPLETE = 'LOGIN_COMPLETE',
  MISSING_EMAIL_VALIDATION = 'MISSING_EMAIL_VALIDATION',
  NEW_PASSWORD_REQUIRED = 'NEW_PASSWORD_REQUIRED',
  MISSING_MFA = 'MISSING_MFA',
}
